<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products?.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <invest-type></invest-type>
              <div class="mt">
                <life-insurance-payment
                  [derrors]="derrors"
                ></life-insurance-payment>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
